import Button from '@rio-cloud/rio-uikit/Button';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { DialogType, useModal } from '@/hooks/useModal';
import { t } from '@/lib/utils';

const SupportModal = () => {
    const [show, setShow] = useState(false);
    const { openDialog, closeDialog } = useModal();

    const title = <FormattedMessage id='general.needSupport.title' />;
    const body = (
        <FormattedMessage
            id='general.needSupport.description'
            values={{
                b: content => <strong>{content}</strong>,
            }}
        />
    );

    const footer = (
        <div className='btn-toolbar justify-content-end'>
            <Button
                onClick={() => {
                    setShow(false);
                    closeDialog();
                }}
                bsStyle='primary'
            >
                <FormattedMessage id='general.button.goBack' />
            </Button>
        </div>
    );

    useEffect(() => {
        if (!show) {
            return;
        }
        openDialog({
            type: DialogType.SIMPLE,
            show,
            onClose: () => {
                setShow(false);
            },
            title,
            body,
            showCloseButton: false,
            bsSize: 'sm',
            footer,
        });
    }, [show]);

    return (
        <Button
            bsStyle={Button.PRIMARY}
            variant={Button.VARIANT_LINK}
            iconName='rioglyph-question-sign'
            className='gap-0'
            onClick={() => setShow(true)}
        >
            {t('general.button.needSupport')}
        </Button>
    );
};

export default SupportModal;
